export const generateAssets = <T extends Record<string, { alias: string, src: string }>>(bundle: T) => {
    type BundleKeys = keyof typeof bundle;
    type BundleType = Record<BundleKeys, string>;

    const assets: BundleType = (Object.keys(bundle) as BundleKeys[]).reduce((obj, key) => {
        obj[key] = bundle[key].alias;
        return obj;
    }, {} as BundleType) as BundleType;

    return assets;
}